import React from "react";
import { Badge, Box, Flex, IconButton, useColorModeValue } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { MdNotificationsNone } from "react-icons/md";
import useAdminNotifications from "./useAdminNotifications";

/**
 * Navbar bell showing the number of unread admin incidents and linking to the
 * notification centre. Mounted in the navbar so an incident is visible from
 * any screen, not only from the one that raised it.
 * @returns {React.ReactElement}
 */
function NotificationBell() {
    const navigate = useNavigate();
    const { unread } = useAdminNotifications();
    const navbarIcon = useColorModeValue("gray.400", "white");

    return (
        <Box position="relative">
            <IconButton
                aria-label="Notifications"
                size="sm"
                variant="ghost"
                color={navbarIcon}
                icon={<Box as={MdNotificationsNone} fontSize="18px" />}
                onClick={() => navigate("/admin/notifications")}
            />
            {unread > 0 && (
                <Flex
                    position="absolute"
                    top="-2px"
                    right="-2px"
                    pointerEvents="none"
                    align="center"
                    justify="center"
                >
                    <Badge
                        colorScheme="red"
                        borderRadius="full"
                        fontSize="10px"
                        px="5px"
                        minW="18px"
                        textAlign="center"
                    >
                        {unread > 99 ? "99+" : unread}
                    </Badge>
                </Flex>
            )}
        </Box>
    );
}

export default NotificationBell;
